export default __webpack_public_path__ + "static/media/wings.80966a73.jpg";